
import { MapLocation } from '@/types/location';

// Striker Gym Locations
export const strikerGyms: MapLocation[] = [
  {
    id: 18001,
    name: "Striker Gym - Riyadh (Al Olaiya) Male",
    type: "Gym",
    devices: 3,
    coordinates: [24.68568918654316, 46.689659764417655],
    region: "Riyadh",
    mediaOwner: "Alan",
    mediaKind: "Indoor",
    screenType: "Portrait Screens",
    gender: "Male",
    ageRange: "15-40",
    orientation: "Portrait",
    segment: "Fitness"
  },
  {
    id: 18002,
    name: "Striker Gym - Riyadh Female",
    type: "Gym",
    devices: 2,
    coordinates: [24.685780598044147, 46.68942449458813],
    region: "Riyadh",
    mediaOwner: "Alan",
    mediaKind: "Indoor",
    screenType: "Portrait Screens",
    gender: "Female",
    ageRange: "15-40",
    orientation: "Portrait",
    segment: "Fitness"
  }
];
